import styled from "styled-components"
import colors from "../../utils/style/colors.tsx"
// import Check from "../../assets/images/check.png"
// import Croix from "../../assets/images/croix.png"
// import Params from "../../assets/images/params.png"

const CardWrapper = styled.div`
    background-color: ${({ color }) => color};
    border-radius: 15px;
    padding: 20px;
    margin: 15px;
    text-align: center;
    position: relative;
    width: 18vw;
    border: solid 5px ${colors.black};
    margin-bottom: 7vw;
    padding-bottom: 10%;
    height: 400px;
    transition: all ease 0.3s;

    @media (max-width: 1440px) {
        height: 440px;
    }

    
    @media (max-width: 1020px) {
        width: 26vw;
        height: fit-content;
    }

    @media (max-width: 768px) {
        width: 32vw;
    }
      
    @media (max-width: 655px) {
        width: 40vw;
    }

    @media (max-width: 520px) {
        width: 48vw;
    }

    @media (max-width: 400px) {
        width: 58vw;
        margin-left: auto;
    }

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 15px;
        background-color: ${({ color }) => color};
        z-index: -1;
        box-shadow: 13px 13px ${colors.black};
    }

    
    &:hover{
        transition: all ease 0.3s;
        transform: translate(-5px, -5px);
    }
`

const TitleWrapper = styled.div``

const CardTitle = styled.h2`
    font-family: "Archivo Black", sans-serif;
    font-size: 31px;
    margin-bottom: 10px;
    color: ${colors.white};
    text-shadow: 3px 3px ${colors.black};
    -webkit-text-stroke-color: ${colors.black};
    -webkit-text-stroke-width: 1px;
    margin-top: 10px;
    align-content: center;

    @media (min-width: 1300px) {
        min-height: 130px;
    }

    @media (max-width: 1300px) {
        min-height: 105px;
        font-size: 25px;
    }

    
`

const CardText = styled.p`
    font-family: "Archivo Black", sans-serif;
    font-size: 16px;
    margin-bottom: 10px;
    min-height: 50px;
    align-content: center;

    @media (max-width: 1440px) {
        min-height: 70px;
    }
`

const CardPriceWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`

const CardPrice = styled.h3`
    font-size: 80px;
    font-family: "Archivo Black", sans-serif;
    color: ${colors.white};
    margin: 0;
    text-shadow: 3px 3px ${colors.black};
    -webkit-text-stroke-color: ${colors.black};
    -webkit-text-stroke-width: 1px;

    @media (max-width: 1300px) {
        font-size: 65px;
    }

    @media (max-width: 500px) {
        font-size: 50px;
    }
`

const SpanMonnaie = styled.span`
    font-size: 40px;
`

const CardSubText = styled.p`
    font-size: 18px;
    margin-bottom: 10px;
    font-family: "Archivo Black", sans-serif;
    color: ${colors.white};
    text-shadow: 2px 2px ${colors.black};
    -webkit-text-stroke-color: ${colors.black};
    -webkit-text-stroke-width: 0.5px;
    margin: 0;
    text-align: start;
    position: relative;
    top: -20px;
    left: 5px;

    @media (max-width: 1300px) {
        font-size: 16px;
        margin-top: 10px;
    }
`

const CardContentWrapper = styled.div`
    font-family: "Archivo", sans-serif;
    font-weight: 900;
`

const Line = styled.div`
    display: flex;
    text-align: left;
    margin-bottom: 5px;
`

const ImageLine = styled.div`
    padding-right: 20px;
`


function CardOffreDetails({
    titre,
    texte,
    prix,
    monnaie,
    sous_texte,
    color,
    lines,
}) {
    return (
        <CardWrapper color={color}>
            <TitleWrapper>
                <CardTitle>{titre}</CardTitle>
                <CardText>{texte}</CardText>
            </TitleWrapper>
            <CardPriceWrapper>
                <CardPrice>
                    {prix}
                    <SpanMonnaie>{monnaie}</SpanMonnaie>
                    <CardSubText>{sous_texte}</CardSubText>
                </CardPrice>
            </CardPriceWrapper>
            <CardContentWrapper>
                {/* Parcours toutes les "lines" */}
                {Object.keys(lines).map((key) => {
                    const line = lines[key]

                    // Définir l'image correcte selon le symbole
                    var imageSrc = ""

                    if (line.symbole === "check") {
                        imageSrc = "✔"
                    } else if (line.symbole === "croix") {
                        imageSrc = "✖"
                    } else {
                        imageSrc = "⚙"
                    }

                    return (
                        <Line key={key}>
                            <ImageLine>{imageSrc}</ImageLine>
                            {line.phrase}
                        </Line>
                    )
                })}
            </CardContentWrapper>
        </CardWrapper>
    )
}

export default CardOffreDetails
